import { createContext } from 'react';
export const FormContextInstance = createContext({ submitFailed: false });
//# sourceMappingURL=context.js.map